import QRious from '../../util/qrious';
import Clipboard from 'clipboard';
import { SHARE_TYPE } from './constant';
import Tracker from '../tracker';
import Client from '../client';
export default class PCShare {
  constructor(config) {
    this.config = config;
  }
  track(action) {
    let type = SHARE_TYPE[action];
    let channel = Client.getChannel();
    Tracker.record('/aliyun.share.click', 'CLK', `type=${type}&channel=${channel}`);
  }
  async copyLink(config = {}) {
    this.track('PCCOPY');
    return new Promise(resolve => {
      const _config = {
        ...this.config,
        ...config,
      };
      const dom = `<div style="display:none;" data-clipboard-text=${_config.url}></div>`;
      const $target = $(dom);
      const clipboard = new Clipboard($target.get(0));
      clipboard.on('success', () => {
        $target.remove();
        clipboard.destroy();
        resolve(true);
      });
      clipboard.on('success', () => {
        $target.remove();
        clipboard.destroy();
        resolve(false);
      });
      $target.trigger('click');
    });
  }
  dingTrack() {
    this.track('PCDING');
  }
  ding(config = {}) {
    const _config = {
      ...this.config,
      ...config,
    };
    const qr = new QRious({
      value: _config.url,
    });
    // 将二维码转变为base64数据，赋值到图片标签上src
    const imgSrc = qr.toDataURL();
    return imgSrc;
  }
  weixinTrack() {
    this.track('PCWEIXIN');
  }
  weixin(config = {}) {
    const _config = {
      ...this.config,
      ...config,
    };
    const qr = new QRious({
      value: _config.url,
    });
    // 将二维码转变为base64数据，赋值到图片标签上src
    const imgSrc = qr.toDataURL();
    return imgSrc;
  }
  qq(config = {}) {
    this.track('PCQQ');
    const _config = {
      ...this.config,
      ...config,
    };
    return `//connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(_config.url)}&title=${
      _config.title
    }&desc=${_config.content}&pics=${_config.img}&site=阿里云`;
  }
  weibo(config = {}) {
    this.track('PCWEIBO');
    const _config = {
      ...this.config,
      ...config,
    };
    return `//service.weibo.com/share/share.php?url=${encodeURIComponent(_config.url)}&title=${_config.title}&pic=${
      _config.img
    }`;
  }
}



// WEBPACK FOOTER //
// ./src/components/share/pc.js